import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'loansRequest',
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async addRequest({}, params) {
      const { data } = await defaultApi.postLoansRequest(params)

      return data
    },
    async getRequests({}, params) {
      const { data } = await defaultApi.getLoansRequests(
        Object.assign({ page: 1, size: 1000 }, params),
      )
      return data
    },
  },
}
